import './styles.css';

import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
  Tooltip
} from '@chakra-ui/react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import dayjs from 'dayjs';
import { isValidMotionProp, motion } from 'framer-motion';
import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

import { gradientStyle } from '@/utils/styles.utils';

import { getBetRecord } from '../../api/getApi';
import { COMMON_WEB_PATH } from '../../constant';
import BetRecordDetail from './BetRecordDetail';
import useLongMachineSetting from '@/hook/useLongMachineSetting';
import { size } from 'lodash';
import i18next from 'i18next';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const BetRecordButton = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [openModal, setOpenModal] = useState(false);
  const [openBetRecordDetail, setOpenBetRecordDetail] = useState(false);

  const [selectedGame, setSelectedGame] = useState('ALL');
  const [betRecords, setBetRecords] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams();

  const game = searchParams.get('game') || '';

  const handleClick = () => {
    setOpenModal(true);
  };

  const fontStyle = useMemo(() => {
    return {
      className: 'empire_font',
      fontSize: {
        base: '40px'
      },
      color: '#FFC6E5'
    };
  }, []);

  const gameOptions = useMemo(() => {
    return Object.keys(betRecords).length > 0
      ? [
          ...Object.keys(betRecords).filter(
            (key) => betRecords[key].totalBet !== 0 || betRecords[key].totalWinOrLose !== 0
          )
        ]
      : [];
  }, [betRecords]);

  useEffect(() => {
    const fetchBetRecords = async () => {
      setIsLoading(true);
      try {
        // 計算時間範圍：現在到15分鐘前
        const endTime = dayjs();
        const startTime = endTime.subtract(15, 'minute');

        const result = await getBetRecord({
          params: {
            str_date: startTime.toDate(),
            end_date: endTime.toDate()
          }
        });

        if (result && result.data) {
          setBetRecords(result.data);
        }
      } catch (error) {
        console.error('無法獲取投注記錄:', error);
      } finally {
        setIsLoading(false);
      }
    };
    if (openModal) {
      fetchBetRecords();
    }
  }, [openModal]);

  const { longMachinePaddingTop } = useLongMachineSetting();

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.cdnfonts.com/css/a-absolute-empire"
          rel="stylesheet"
        />
      </Helmet>
      <Box
        onClick={handleClick}
        position="relative"
        cursor={'pointer'}
        display="flex"
        alignItems={'center'}
        justifyContent={'center'}
        bgImage={`url('${COMMON_WEB_PATH}/blue-layout/header_button/${i18next.language}/header_bet_record.png')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        height={{
          base: '60px',
          xl: '65px'
        }}
        w={'200px'}
      >
        {/* <Image
          src={`${COMMON_WEB_PATH}/blue-layout/header/bet_record_icon.png`}
          w="40px"
          h="40px"
        />
        <Text
          fontSize={size(i18n('bet record')) > 7 ? '1.3em' : '1.8em'}
          fontWeight={900}
        >
          {i18n('bet record')}
        </Text> */}
      </Box>

      {openModal && (
        <Flex
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bg="rgba(0, 0, 0, 0.8)"
          zIndex="9999"
          //   backdropFilter="blur(2px)"
          justifyContent="center"
          alignItems="center"
          pt={longMachinePaddingTop}
        >
          <BetRecordDetail
            fontStyle={fontStyle}
            setOpenBetRecordDetail={setOpenModal}
            betRecordDetail={betRecords}
            gameOptions={gameOptions}
          />
        </Flex>
      )}
    </>
  );
};

export default BetRecordButton;
